export default "/images/vendor/@coreui/icons/svg/flag/cif-sm.svg?812b30f57b70e6daef7543e8be60e80b";